import colors from './colors';
import typography from './typography';

export { colors, typography };
export default { colors, typography };
